<template>
  <div style="height:700px;overflow:auto">
    <Table
      :columns="tableTitle"
      :data="tableData.data"
      border
      stripe
      show-summary
      :summary-method="handleSummary"
    >
      <template
        v-for="(item, index1) in tableTitle"
        :slot="item.slot"
        slot-scope="{ row, index }"
      >
        <template v-if="item.button">
          <Button
            type="warning"
            @click="handSubmit(row)"
            :key="index1"
            size="small"
            v-if="index == 0 && $hasPermission(328)"
          >
            提交
          </Button>
          <Button
            type="success"
            @click="handSubmit(row)"
            :key="index1"
            size="small"
            v-if="index !== 0 && $hasPermission(558)"
          >
            {{ $t("update") }}
          </Button>
          <Button
            type="error"
            @click="handDelete(index)"
            size="small"
            :key="index1+'del'"
            v-if="($hasPermission(432) || $hasPermission(433)) && row.id"
            style="margin-top: 5px;"
          >
            {{ $t("delete") }}
          </Button>
          <Button
            type="warning"
            @click="preview(row)"
            size="small"
            :key="index1+'preview'"
            v-if="row.inbound_pic"
            style="margin-top: 5px;"
          >
            {{ $t("preview") }}
          </Button>
          <Button
            type="warning"
            @click="uploadPic(row)"
            size="small"
            :key="index1+'preview'"
            v-else-if="index > 0 && !row.inbound_pic"
            style="margin-top: 5px;"
          >
            上传照片
          </Button>
        </template>
        <Input
          :key="index1"
          v-model="tableData.data[index][item.slot]"
          v-else-if="item.input"
          :disabled="tableData.done"
        >
        </Input>
        <InputNumber
          :key="index1"
          v-model="tableData.data[index][item.slot]"
          v-else-if="item.InputNumber"
          :disabled="tableData.done || (typeof item.done === 'function' && item.done(index))"
          :step="item.step"
          :min="0"
          @on-blur="inputBlur(index, item.slot)"
        >
        </InputNumber>
        <template v-else>
          {{ item.color }}
          <span :key="index1">
            {{ tableData.data[index][item.slot] }}
          </span>
        </template>
      </template>
    </Table>
    <div style="
    text-align: center;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    color: red;
">此数据不含 重货比
    </div>

    <Modal
      v-model="showModal"
      :title="title"
      @on-visible-change="closedeleteModal"
      width="600"
    >
      <div slot="footer" class="footer-modal">
        <Button type="primary" @click="confirmModal('dataDetails')">
          {{ $t("confirm") }}
        </Button>
        <Button @click="closeModal">{{ $t("cancel") }}</Button>
      </div>
    </Modal>

    <Modal v-model="uploadPicSymbol" title="请选择四张照片上传" @on-ok="uploadRemote" width="920" height="420">
      <Row :gutter="16">
        <Col :span="6" v-for="(item, key) in [1, 2, 3, 4]">
          <div @click="handleClick(item)" class="preview-style" @mouseenter="isHovering['F' + item] = true"
               @mouseleave="isHovering['F' + item] = false">
            <div v-if="!previewImage['F' + item]" class="upload-content">
              <Icon type="md-add" size="30"/>
              <div class="upload-text">请选择图片上传</div>
            </div>
            <img v-if="previewImage['F' + item]" :src="previewImage['F' + item]" class="preview-image"/>
            <div v-show="isHovering['F' + item]" v-if="previewImage['F' + item]" class="overlay"
                 @click.stop="removeImage('F' + item)">
              <Icon type="md-trash" size="30" color="#fff"/>
            </div>
            <input type="file" :ref="'fileInput' + item" @change="handleUpload($event, item)" accept=".jpg,.png"
                   style="display: none"/>
          </div>
        </Col>
      </Row>
    </Modal>
  </div>
</template>
<script>
import {
  getB2bInbound,
  addB2bInbound,
  updateB2bInbound,
  Del, uploadProofImage,
} from "@/api/double/list";

import boxMes from "@/utils/message";

export default {
  props: {
    billId: {
      type: String
    }
  },
  data() {
    return {
      tableData: {},
      loading: true,
      pageCurrent: 1,
      showModal: false,
      title: "",
      totalData: {},
      uploadPicSymbol: false,
      currentId: 0,
      previewImage: {F1: null, F2: null, F3: null, F4: null},
      isHovering: {F1: false, F2: false, F3: false, F4: false}
    }
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("createTime"),
        key: "create_time",
        align: "center",
        width: 110,
        classname: "123"
      });
      columns.push({
        title: this.$t("operate"),
        key: "operator_name",
        align: "center",
        width: 100,
        tooltip: true
      });
      columns.push({
        title: this.$t("warehouseName"),
        key: "warehouse_name",
        align: "center",
        width: 100,
        tooltip: true
      });
      columns.push({
        title: this.$t("totalNoofpieces"),
        slot: "total_nums",
        key: "total_nums",
        align: "center",
        width: 120
      });
      columns.push({
        title: this.$t("inbound") + this.$t("caseNumber"),
        slot: "quantity",
        key: "quantity",
        align: "center",
        minWidth: 100,
        InputNumber: true,
        step: 1,
        done: (index) => {
          return index > 0;
        }
      });
      columns.push({
        title: "箱号",
        key: "case_number",
        slot: "case_number",
        align: "center",
        minWidth: 180,
        input: true
      });
      columns.push({
        title: this.$t("length") + "CM",
        key: "length",
        slot: "length",
        align: "center",
        minWidth: 100,
        InputNumber: true,
        step: 0.01,
        done: (index) => {
          return index > 0;
        }
      });
      columns.push({
        title: this.$t("width") + "CM",
        slot: "width",
        key: "width",
        align: "center",
        minWidth: 120,
        InputNumber: true,
        step: 0.01,
        done: (index) => {
          return index > 0;
        }
      });
      columns.push({
        title: this.$t("height") + "(CM)",
        slot: "height",
        key: "height",

        align: "center",
        minWidth: 100,
        InputNumber: true,
        step: 0.01,
        done: (index) => {
          return index > 0;
        }
      });
      columns.push({
        title: this.$t("skuVolume") + "(CBM)",
        slot: "volume",
        key: "volume",
        align: "center",
        minWidth: 100,
        InputNumber: true,
        step: 0.000001,
        done: (index) => {
          return index > 0;
        }
      });
      // columns.push({
      //   title: this.$t("charge_volume") + "(KG)",
      //   key: "volume_weight",
      //   slot: "volume_weight",
      //   align: "center",
      //   minWidth: 120,
      //   InputNumber: true,
      //   step: 0.1
      // });
      columns.push({
        title: this.$t("actual_weight") + "(KG)",
        slot: "actual_weight",
        key: "actual_weight",
        align: "center",
        minWidth: 110,
        InputNumber: true,
        step: 0.000001,
        done: (index) => {
          return index > 0;
        }
      });
      // columns.push({
      //   title: "总重量" + "KG",
      //   slot: "total_weight",
      //   align: "center",
      //   minWidth: 110,
      //   InputNumber: true,
      //   step: 0.0001
      // });
      columns.push({
        title: this.$t("order_desc"),
        slot: "remarks",
        align: "center",
        key: "remarks",
        minWidth: 100,
        input: true
      });
      if (!this.tableData.done) {
        columns.push({
          title: this.$t("operation"),
          slot: "operation",
          align: "center",
          width: 100,
          button: true
        });
      }
      return columns;
    }
  },
  mounted() {
    this.getList(this.billId);
  },
  methods: {
    handleSummary({columns}) {
      const sums = {};
      let keys = [
        '合计',
        this.$t("inbound") + this.$t("caseNumber"),
        this.totalData['quantity'] + '',
        this.$t("skuVolume") + "(CBM)",
        this.totalData['volume'] + '',
        this.$t("actual_weight") + "(KG)",
        this.totalData['actual_weight'] + '',
        this.$t("charge_volume") + "(KG)",
        this.totalData['volume_weight'] + ''
      ]
      columns.forEach((column, index) => {
        const key = column.key;
        sums[key] = {
          key,
          value: keys[index] || '-',
          color: "red"
        };
      });
      console.log(sums);
      return sums;
    },
    inputBlur(index, text) {
      if (text == "total_weight") {
        this.tableData.data.map(item => {
          item[text] = this.tableData.data[index][text];
        });
        return;
      }
      if (
        text == "width" ||
        text == "length" ||
        text == "height" ||
        text == "quantity"
      ) {
        let data = this.tableData.data[index];
        this.tableData.data[index]["volume"] = Math.round(parseFloat(
          (
            (data["width"] *
              data["length"] *
              data["height"] *
              data["quantity"]) /
            1000000
          ) * 100)
        ) / 100;
        this.tableData.data[index]["volume_weight"] = parseFloat(
          (
            (data["width"] *
              data["length"] *
              data["height"] *
              data["quantity"]) /
            6000
          ).toFixed(6)
        );
      }
    },
    handDelete(index) {
      let row = this.tableData.data[index]
      if (row.id) {
        this.$Modal.confirm({
          title:
            this.$t("whether") +
            this.$t("confirm") +
            this.$t("delete") +
            "?",
          onOk: () => {
            Del(row.id).then(res => {
              this.$Message[res.data.status ? "success" : "error"]({
                background: true,
                content: res.data.msg,
                duration: 5,
              });
              this.tableData.data.splice(index, 1)
            })
          },
        });

      }
    },
    preview(data) {
      window.open(data.inbound_pic)
    },
    uploadRemote() {
      // 检查是否4个都上传了
      let symbol = Object.values(this.previewImage).map(v => v ? 1 : 0).join('+')
      if (eval(symbol) !== 4) {
        this.$Message.error('请上传四张照片后在继续操作')
        return false
      }
      // 执行远程数据上传
      this.$Spin.show()
      uploadProofImage({
        imageSet: Object.values(this.previewImage),
        recordId: this.currentId
      }).then(res => {
        this.$Spin.hide()
        this.$Message.info(res.data.msg)
        this.currentId = 0;
        this.previewImage = {F1: null, F2: null, F3: null, F4: null};
        this.isHovering = {F1: false, F2: false, F3: false, F4: false};
        for (let i = 1; i <=4 ; i++) {
          this.$refs['fileInputK' + i][0].value = null
        }
        this.uploadPicSymbol = false;
      })

    },
    handleClick(key) {
      if (!this.previewImage[key]) {
        this.$refs['fileInput' + key][0].click();
      }
    },
    removeImage(key) {
      this.previewImage[key] = null;
      this.$refs['fileInput' + key][0].value = null;
    },
    handleUpload($event, key) {
      const file = $event.target.files[0];
      if (!file) return;
      if (file.size > 4 * 1024 * 1024) {
        this.$Message.error('图片大小不能超过 4MB');
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewImage['F' + key] = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadPic(data) {
      this.currentId = data.id
      this.uploadPicSymbol = true
    },

    handSubmit(data) {
      delete data.warehouse_name;
      delete data.total_nums;
      delete data.create_time;
      delete data.operator_name;
      if (data.id) {
        updateB2bInbound(data).then(res => {
          this.$Message[res.data.status ? "success" : "error"]({
            background: true,
            content: res.data.msg,
            duration: 5
          });
          if (res.data.status) {
            this.getList(this.billId);
            this.$parent.$parent.$page.getList();
            this.$parent.$parent.$page.closeLoading();
          }
        });
      } else {
        addB2bInbound(this.billId, data).then(res => {
          this.$Message[res.data.status ? "success" : "error"]({
            background: true,
            content: res.data.msg,
            duration: 5
          });
          if (res.data.status) {
            this.getList(this.billId);
            this.$parent.$parent.$page.getList();
            this.$parent.$parent.$page.closeLoading();
          }
        });
      }
    },
    closeModal() {
      this.closedeleteModal(false);
    },
    closedeleteModal(e) {
      if (e === false) {
        this.showModal = false;
        this.searchFrom.keywords = "";
        this.feeData = [];
        this.$refs["dataDetails"].resetFields();
      }
    },
    confirmModal(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let ids = this.selectAll.map(item => {
            return item.id;
          });
          this.dataDetails.ids = ids;
          hangBill(this.billId, this.dataDetails).then(res => {
            if (res.status) {
              this.$Message["success"]({
                background: true,
                content: res.data.msg
              });
              this.closeModal();
            } else {
              this.$Message["error"]({
                background: true,
                content: res.data.msg,
                duration: 5
              });
            }
          });
          this.deleteList(arr);
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    crudClick(item) {
      getFreight(this.billId, item.id).then(res => {
        if (res.data.payload.length > 0) {
          this.feeData = res.data.payload;
        } else {
          this.feeData = [
            {
              expense_item_id: "",
              expense_item_name: "",
              amount: 0
            }
          ];
        }
      });
      if (this.status == "WAIT_CONFIRM") {
        this.hideFooter = false;
      }
      this.showModal = true;
      this.updateId = item.id;
    },
    getList(id) {
      this.tableData = {};
      this.loading = true;
      getB2bInbound(id)
        .then(res => {
          this.loading = false;
          if (!res.data.status) {
            boxMes.alertMes(res, this);
            return;
          }
          this.tableData = res.data.payload;
          if (!res.data.payload.done) {
            this.tableData.data.unshift({
              // airway_bill_number: "",
              remarks: "",
              quantity: 0,
              total_nums: res.data.payload.total_nums,
              create_time: "",
              operator_name: "",
              warehouse_name: "",
              case_number: "",
              length: 0,
              width: 0,
              height: 0,
              volume: 0,
              actual_weight: 0,
              volume_weight: 0
              // total_weight: 0
            });
          }
          this.totalData = res.data.payload.total;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style>
.ivu-table-summary {
  color: red !important;
}

.delBtn {
  margin: 0 10px;
}

.ivu-page {
  margin-top: 20px;
}

.footer-modal {
  width: 100%;
  text-align: center;
}

.bill-form .ivu-form-item {
  margin-bottom: 10px;
}

.preview-style {
  width: 200px;
  height: 200px;
  border: 1px solid #ccc;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.upload-content {
  text-align: center;
}

.upload-text {
  margin-top: 5px;
  font-size: 14px;
  color: #666;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
